import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MomentModule } from 'angular2-moment';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgSlimScrollModule } from "../../../node_modules/ngx-slimscroll/src/ngx-slimscroll/module/ngx-slimscroll.module";
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { BusyModule } from 'angular2-busy';

// Common Features Module
import { BrightServeCommonModule } from 'app/common/brightserve-common.module';

import { BrightServeModule } from "app/brightserve/brightserve.module";
import { AuthGuard } from "app/brightserve/auth-guard";
import { SharedModule } from "app/shared/shared.module";
import { AddonModule } from "app/add-ons/addon.module";

import { CaseComponent } from './list/case.component';
import { CaseDetailsComponent } from './details/case-details.component';

import { CaseService } from "app/case/case.service";
import { CaseDetailsReportComponent } from './details/report/case-details-report.component';
import { CaseDetailsMonitoringComponent } from './details/monitoring/case-details-monitoring.component';
import { CaseDetailsTrendsComponent } from './details/trends/case-details-trends.component';
import { CaseDetailsMediaComponent } from './details/media/case-details-media.component';

const CaseRoutes: Routes = [
    { path: 'cases/current', component: CaseComponent, data: { Type: "Current" }, canActivate: [AuthGuard] },
    { path: 'cases/current/:assignment', component: CaseComponent, data: { Type: "Current" }, canActivate: [AuthGuard] },
    { path: 'cases/suspended', component: CaseComponent, data: { Type: "Suspended" }, canActivate: [AuthGuard] },
    { path: 'cases/suspended/:assignment', component: CaseComponent, data: { Type: "Suspended" }, canActivate: [AuthGuard] },
    { path: 'cases/closed', component: CaseComponent, data: { Type: "Closed" }, canActivate: [AuthGuard] },
    { path: 'cases/closed/:assignment', component: CaseComponent, data: { Type: "Closed" }, canActivate: [AuthGuard] },
	{ path: 'case/:id', component: CaseDetailsComponent, children: [
		{ path: '', redirectTo: 'report', pathMatch: 'full' },
		{ path: 'report', component: CaseDetailsReportComponent  },
		{ path: 'monitoring', component: CaseDetailsMonitoringComponent },
		{ path: 'trends', component: CaseDetailsTrendsComponent },
		{ path: 'media', component: CaseDetailsMediaComponent }
    ], canActivate: [AuthGuard]},
];

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		RouterModule.forChild(CaseRoutes),
		NgbModule,
        MomentModule,
        ModalModule,
        NgSlimScrollModule,
        InfiniteScrollModule,
        BusyModule,
        BrightServeCommonModule,
        BrightServeModule,
		SharedModule,
        AddonModule
	],
	declarations: [
		CaseComponent,
		CaseDetailsComponent,
		CaseDetailsMediaComponent,
		CaseDetailsMonitoringComponent,
		CaseDetailsReportComponent,
		CaseDetailsTrendsComponent,
	],
	providers: [
		CaseService
	]
})
export class CaseModule { }



// WEBPACK FOOTER //
// ./src/app/case/case.module.ts